import { Div, RefString, Select, SelectOption } from "@tblabs/truffle";
import { RawProductFromWebsite } from "../Models/ProductsCatalog/RawProduct";
import { RawProductOptionFromWebsite } from "../Models/ProductsCatalog/RawProductOption";
import { BasketItem } from "../Models/Basket/BasketItem";
import { WebsiteProductConverter } from "../Pages/Admin/OrderEdit/Components/ProductConverter";


export class ProductSelector extends Div
{
    private productId = new RefString().OnChange(() => this.Refresh())
    private optionId = new RefString().OnChange(() => this.Refresh())

    constructor(
        private productsInfo: RawProductFromWebsite[],
        private basketItem: BasketItem)
    {
        super();

        const productsNames = productsInfo.map(p => new SelectOption(p.Title, p.Id));

        this.productId.value = this.basketItem?.ProductInfo.Id || "";
        this.optionId.value = this.basketItem?.Option.Id || "";

        this.Append(
            new Select(this.productId, productsNames)
                .WidthAuto()
            ,
            new Select(this.optionId, () => this.OptionsLabelsForSelectedProduct(productsInfo), this.productId).WidthAuto()
                .AddDefaultOption("(wybierz opcję)")
                .VisibleWhen(this.productId, () => this.OptionsLabelsForSelectedProduct(productsInfo).length > 0)
        );
    }

    private OptionsLabelsForSelectedProduct(productsInfo: RawProductFromWebsite[]): SelectOption<string>[]
    {
        const product = productsInfo.find(x => x.Id == this.productId.value);

        const productOptions = product?.Options.List.map(o => new SelectOption(o.Label, o.Url)) || [];

        return productOptions;
    }

    public Refresh()
    {
        const product = this.productsInfo.find(x => x.Id == this.productId.value);

        if (!product)
            return;

        let option = product.Options.List.find(o => o.Url == this.optionId.value);

        const defaultOption = { Url: "opcja-domyslna", Label: "", Description: "Opcja domyślna", PriceFactor: 1 } as RawProductOptionFromWebsite;

        if (!option)
            option = defaultOption;

        this.basketItem.Set(WebsiteProductConverter.ToBasketProduct(product, option));
    }
}
